var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { AsyncPanel, Resize } from '@pawgame/laya-game-sdk';
export class HomePanel extends AsyncPanel {
    constructor() {
        super('res/ui/home', 'UI_home');
        this._itemsData = [
            {
                id: '1',
                icon: '1',
                name: '小茶陶瓷保温杯',
            },
            {
                id: '2',
                icon: '2',
                name: 'LULU猪小夜灯',
            },
            {
                id: '3',
                icon: '3',
                name: 'SONY挂脖蓝牙耳机',
            },
            {
                id: '4',
                icon: '4',
                name: '野兽派香氛礼盒',
            },
            {
                id: '5',
                icon: '5',
                name: '小米保温杯+五折伞',
            },
            {
                id: '6',
                icon: '6',
                name: '水星加湿器',
            },
            {
                id: '7',
                icon: '7',
                name: '九阳养生壶',
            },
            {
                id: '8',
                icon: '8',
                name: '九阳恒温神器',
            },
            {
                id: '9',
                icon: '9',
                name: '九阳电火锅',
            },
        ];
    }
    doReady() {
        const _super = Object.create(null, {
            doReady: { get: () => super.doReady }
        });
        return __awaiter(this, void 0, void 0, function* () {
            _super.doReady.call(this);
            this._isScene = true;
            this._isCenter = true;
            const safeY = Resize.getSafeY();
            this._skin.y = safeY;
            this._skin.setSize(Resize.getWidth(), Resize.getHeight() - safeY);
            const allItems = [
                this.$skin.item_1,
                this.$skin.item_2,
                this.$skin.item_3,
                this.$skin.item_4,
                this.$skin.item_5,
                this.$skin.item_6,
                this.$skin.item_7,
                this.$skin.item_8,
                this.$skin.item_9,
            ];
            allItems.forEach((item, i) => {
                const itemData = this._itemsData[i];
                itemData.isOpen = localStorage.getItem(`${itemData.id}_isOpen`) === '1';
                item.data = itemData;
                if (itemData.isOpen) {
                    item.$skin.icon.url = fgui.UIPackage.getItemURL('home', itemData.icon);
                }
                else {
                    item.onClick(this, this.onItemClick, [item]);
                    item.$skin.effect.content.setPlaySettings(0, -1, 1, -1, Laya.Handler.create(this, this.onItemPlayComplete, [item]));
                }
            });
        });
    }
    onItemClick(item) {
        const itemData = item.data;
        if (itemData.isOpen)
            return;
        item.$skin.effect.url = fgui.UIPackage.getItemURL('effect', 'mc_heart');
        itemData.isOpen = true;
        localStorage.setItem(`${itemData.id}_isOpen`, '1');
    }
    onItemPlayComplete(item) {
        const itemData = item.data;
        item.$skin.effect.url = null;
        item.$skin.icon.url = fgui.UIPackage.getItemURL('home', itemData.icon);
    }
}
//# sourceMappingURL=HomePanel.js.map